/**
 * The bell chrome ISSUE-324 reserved for ISSUE-326.
 *
 * Label-only, matching SectionNav: the repo ships no icon set. The count
 * comes from useShellBadges, the same wiring point as Invite and Messages.
 */
import { FOCUS_RING } from "@sportsmet/ui";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { NavBadge } from "./NavBadge";
import { useShellBadges } from "./useShellBadges";

export const NotificationBell = (): ReactNode => {
  const badges = useShellBadges();

  return (
    <Link
      to="/notifications"
      className={`flex min-h-touch-target items-center gap-1 px-2 text-body-strong text-ink no-underline ${FOCUS_RING}`}
    >
      Notifications
      <NavBadge
        count={badges.notificationCount}
        singularLabel="unread notification"
        pluralLabel="unread notifications"
      />
    </Link>
  );
};
